import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type AscProjectDetailAnalyticIds = {
  nameId: string;
  descriptionId: string;
  productId: string;
  clearProductBtnId: string;
};

export const useAscProjectDetailAnalyticIds = (): AscProjectDetailAnalyticIds => ({
  nameId: useAnalyticId(AnalyticIdentifier.ASC_PROJECT_DETAIL_NAME),
  descriptionId: useAnalyticId(AnalyticIdentifier.ASC_PROJECT_DETAIL_DESCRIPTION),
  productId: useAnalyticId(AnalyticIdentifier.ASC_PROJECT_DETAIL_PRODUCT),
  clearProductBtnId: useAnalyticId(AnalyticIdentifier.ASC_PROJECT_DETAIL_PRODUCT_CLEAR_BUTTON),
});
